import PropTypes from 'prop-types';

import { withCurrency } from '../currency';
import { CurrencyFormatter as formatter } from '../../utils/Intl';

/* istanbul ignore if  */
if (!global.Intl) {
    require('intl');
    require('intl/locale-data/jsonp/de');
    require('intl/locale-data/jsonp/en');
    require('intl/locale-data/jsonp/es');
    require('intl/locale-data/jsonp/fr');
    require('intl/locale-data/jsonp/it');
    require('intl/locale-data/jsonp/nl');
    require('intl/locale-data/jsonp/pt');
}

export const CurrencyFormatter = (props) =>
    formatter.format(props.value, props.currency, {
        currencyDisplay: props.currencyDisplay,
        useGrouping: props.useGrouping,
        minimumIntegerDigits: props.minimumIntegerDigits,
        minimumFractionDigits: props.minimumFractionDigits,
        maximumFractionDigits: props.maximumFractionDigits,
        minimumSignificantDigits: props.minimumSignificantDigits,
        maximumSignificantDigits: props.maximumSignificantDigits
    });

CurrencyFormatter.propTypes = {
    value: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    currencyDisplay: PropTypes.oneOf(['symbol', 'code', 'name']),
    useGrouping: PropTypes.bool,
    minimumIntegerDigits: PropTypes.number,
    minimumFractionDigits: PropTypes.number,
    maximumFractionDigits: PropTypes.number,
    minimumSignificantDigits: PropTypes.number,
    maximumSignificantDigits: PropTypes.number
};

CurrencyFormatter.defaultProps = {
    value: 0,
    currency: 'EUR',
    currencyDisplay: 'symbol'
};

export default withCurrency(CurrencyFormatter);
